module.exports = __webpack_public_path__ + "static/media/logo.8cd7b510.png";